import React from "react"

function OptionButton(props) {

    const handleClick = (event) => {
        props.setChoice(props.text)
        props.showSteps()

        if (typeof document !== 'undefined') {
            const elements = document.querySelectorAll(".optionbutton")
            elements.forEach((element) => {
                element.classList.remove("optionbuttonactive")
            })
            event.target.classList.add("optionbuttonactive")
        }
    }

    return (
        <button className="optionbutton" onClick={handleClick}>
            {props.text}
        </button>
    )
}

export default OptionButton